import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="沐燁文化"
        brandName="沐燁文化"
        englishName="MOYA"
        tagline="從不同知識領域，找到理解生活的路徑"
      />
      <Footer />
    </>
  );
}

